module.exports = __webpack_public_path__ + "static/media/subnivel.a0c393c9.png";